module.exports = __webpack_public_path__ + "img/jobapplication.6a1ac4e1.svg";